import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import type { U3500NasSync } from '../../../u3500GedDocumentSearch/U3500Service';
import { NS } from '../../U3121';
import {
  u3121FormatNasSyncLastAt,
  u3121NasSyncBadgeClass,
  u3121NasSyncStatusLabelKey,
} from '../../tools/u3121NasSyncDisplay';

interface U3121NasSyncStatusProps {
  sync: U3500NasSync | null | undefined;
  t: TFunction;
}

/** Badge + date (inline) — sans titre « Synchro NAS ». */
function U3121NasSyncStatus({ sync, t }: U3121NasSyncStatusProps) {
  const { i18n } = useTranslation();
  const status = sync?.status ?? 'never';
  const lastSyncFormatted = u3121FormatNasSyncLastAt(sync?.lastSyncedAt, i18n.language);
  const errorReason = status === 'error' && sync?.errorReason?.trim() ? sync.errorReason.trim() : null;

  return (
    <div className="flex min-w-0 flex-nowrap items-center justify-end gap-2 overflow-hidden">
      <span className={`shrink-0 rounded-sm px-2 py-0.5 text-xs font-medium ${u3121NasSyncBadgeClass(status)}`}>
        {t(u3121NasSyncStatusLabelKey(status), { ns: NS })}
      </span>
      {lastSyncFormatted && (
        <span className="truncate text-xs font-normal text-gray-500">{lastSyncFormatted}</span>
      )}
      {errorReason ? <span className="truncate text-xs font-normal text-red-700">{errorReason}</span> : null}
    </div>
  );
}

export default U3121NasSyncStatus;
